import { AITrafficShapingView } from "@tiny/api";
import {
  ActionTimeInfo,
  TimeAction,
} from "@tiny/components/src/ItemActionTimeInfo/ItemActionTimeInfo.types";

export const dateFormat = "dd MMM, yy - hh:mm a";

export function getTimeActionsInfo(
  mdUp: boolean,
  trafficShaping: AITrafficShapingView,
  sortAction?: TimeAction
): ActionTimeInfo[] {
  const createdDate: ActionTimeInfo = {
    action: "Created",
    timestamp: trafficShaping.createdAt,
  };
  const modifiedDate: ActionTimeInfo = {
    action: "Modified",
    timestamp: trafficShaping.updatedAt,
  };
  const actions: ActionTimeInfo[] = [];
  if (sortAction === "Modified") {
    actions.push(modifiedDate);
    mdUp && actions.push(createdDate);
  } else if (sortAction === "Created") {
    actions.push(createdDate);
    mdUp && actions.push(modifiedDate);
  } else {
    actions.push(createdDate);
  }

  return actions;
}

export const warmupTypeLabelMap: Record<string, string> = {
  COLD: "Brand New Domain",
  MIGRATION: "Domain Migration - Moving from Another ESP",
  EXISTING: "Existing Domain - Currently Sending on tinyEmail",
};
